import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_AUDIENCE, setAccessTokenGetter, setLoginRedirect } from '../services/authToken';

/**
 * Registers Auth0's token getter with the API module. Rendered before <App /> and set during render (not in an
 * effect), so it's in place before any page fetches data.
 */
export const AuthTokenBridge: React.FC = () => {
  const { isAuthenticated, getAccessTokenSilently, loginWithRedirect } = useAuth0();
  const active = isAuthenticated && !!AUTH0_AUDIENCE;
  setAccessTokenGetter(active ? getAccessTokenSilently : null);
  setLoginRedirect(active ? () => void loginWithRedirect() : null);
  return null;
};
